'use client';

import { useMergeRefs } from '@floating-ui/react';
import { forwardRef, useContext } from 'react';

import { Slot } from '../slot';
import { TriggerButton } from '../trigger-button/trigger-button';
import { TooltipRootContext } from './context/tooltip-root.context';
import type { TooltipTriggerPropsInterface } from './types/tooltip-trigger.types';

/**
 * @since 10.0.0
 */
export const TooltipTrigger = forwardRef<HTMLButtonElement, TooltipTriggerPropsInterface>(
  (props: TooltipTriggerPropsInterface, forwardedRef) => {
    const { children = <TriggerButton />, ...rest } = props;
    const { tooltip } = useContext(TooltipRootContext);
    const mergedRefs = useMergeRefs([tooltip.refs.setReference, forwardedRef]);

    return (
      <Slot
        ref={mergedRefs}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Tooltip.Trigger"
        {...tooltip.getReferenceProps(rest)}
      >
        {children}
      </Slot>
    );
  },
);

TooltipTrigger.displayName = 'Tooltip.Trigger';
